export default __webpack_public_path__ + "static/media/sennheiser.07537315.png";